module.exports = __webpack_public_path__ + "media/custom/images/pocstock-contest-image-c2e9d11fb4a76a27eb10476a3c887871.png";